import useBomDashboard from "./useBomDashboard";
import { yearOptions } from "@/lib/utils";
import { FormLabel, Select } from "@/components";
import { CriticalActionSection } from "./CriticalActionSection";
import { BudgetCard } from "./BudgetCard";
import { ApprovalSettingsDtlCard } from "./ApprovalSettingsDtlCard";
import { NewsLetterCard } from "../NewsLetterCard";
import { Operational } from "./Operational";
import { ReportSection } from "../ReportSection";
import { CommunityOverview } from "./CommunityOverview";

const BomDashboard = () => {
  const {
    loggedInUserData,
    communityData,
    currentFinanceYear,
    onYearChange,
  } = useBomDashboard();

  return (
    <div className="grid grid-cols-1 gap-[20px]">
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-[20px]">
        <div className="grid grid-cols-1 gap-[20px] lg:col-span-3">
          <div className="bg-white rounded-lg p-[20px] grid grid-cols-1 lg:grid-cols-3 gap-[10px]">
            <div className="flex flex-col col-span-2">
              <span className="font-[300] text-[24px]">
                Hello, {loggedInUserData?.fullName || ""}
                <br />{" "}
                <span className="font-[600]">
                  {communityData?.communityName || ""} -{" "}
                  {communityData?.bomPosition?.positionName || ""}
                </span>
              </span>{" "}
            </div> 
            <div className="flex justify-end">
              <div className="relative w-30 min-w-30 max-w-30 shrink-0">
                <FormLabel>Budget Year</FormLabel>
                <Select
                  showSearch={false}
                  placeholder=""
                  searchPlaceholder=""
                  noDataPlaceholder=""
                  options={yearOptions(5)?.map((d: any) => ({
                    value: d.value,
                    label: d.label,
                  }))}
                  value={currentFinanceYear}
                  onChange={onYearChange}
                  className="h-[36px] w-full"
                />
              </div>
            </div>
          </div>
          <CriticalActionSection />
          <BudgetCard />
        </div>
        <NewsLetterCard />
      </div>
      <ApprovalSettingsDtlCard />
      <Operational />
      <ReportSection />
      <CommunityOverview />
    </div>
  );
};

export default BomDashboard;
